<template>
    <div class="vote" v-loading='proloading'>
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f u-jsb" :inline="true">
                <div>
                    <el-form-item>
                        <el-button type="primary" size="small" @click="search">
                            刷新
                        </el-button>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">
                            新增奖品
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <el-table :data="proData" border v-loading="loading" :height="height" class="tableLimit votebox">
            <el-table-column prop="vote_name" type="index" label="序号" width="80" align='center'></el-table-column>
            <el-table-column prop="award_name" label="奖品名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="grade" label="奖品等级" show-overflow-tooltip></el-table-column>
            <el-table-column prop="problem" label="奖品图片">
                <template slot-scope="{row}">
                    <el-image style="width: 80px; height: 80px" v-if="row.award_cover.length>0" fit='cover'
                        :src="row.award_cover[0].url" :preview-src-list="[row.award_cover[0].url]">
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column prop="award_describe" label="奖品描述" show-overflow-tooltip></el-table-column>
            <el-table-column prop="award_count" label="奖品数量/剩余" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <span>{{row.award_count}}/{{row.award_surplus}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="award_count" label="中奖几率" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <span>{{floatMul(row.rate,100)}}%</span>
                </template>
            </el-table-column>
            <el-table-column prop="award_count" label="状态" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <span>{{({1:'显示',2:'隐藏'})[row.status]}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="award_count" label="默认奖项" show-overflow-tooltip align='center'>
                <template slot-scope="{row}">
                    <el-switch v-model="row.is_default" :active-value="1" :inactive-value='0' active-color="#13ce66"
                        inactive-color="#ff4949" :disabled='row.is_default==1' @change='changeDefault(row.id)'>
                    </el-switch>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                        @click="handleEdit(scope.row,scope.$index)"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-delete"
                        @click="handleDelet(scope.row,scope.$index)"></el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="新建" :visible.sync="adddialogVisible" top="50px" width="50%" class="dialogs" append-to-body>
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="problems" ref="ruleForm" label-width="150px"
                    class="demo-ruleForm forms-lines">
                    <div class="problem_box">
                        <el-form-item label="奖品名称" style="margin-top:10px" prop="award_name">
                            <el-input v-model="ruleForm.award_name" placeholder="请输入奖品名称" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="奖品描述" style="margin-top:10px" prop="award_describe">
                            <el-input v-model="ruleForm.award_describe" placeholder="请输入奖品描述" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="奖品图片" style="margin-top:10px">
                            <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
                                :headers="{ token:$store.state.user.token }"
                                :data="{ image_class_id:'72',file_type:'1' }" :limit="1"
                                :file-list="ruleForm.award_cover" :on-success="uploadSuccess" :on-remove="uploadRmove"
                                list-type="picture-card">
                                <i class="el-icon-plus"></i>
                                <!-- verification:1,fileS:2,fileH:300,fileW:300  -->
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="奖品等级" style="margin-top:10px" prop="grade">
                            <el-input v-model="ruleForm.grade" size="small" placeholder="请输入奖品等级"></el-input>
                        </el-form-item>
                        <el-form-item label="奖品类型" style="margin-top:10px" prop="type">
                            <el-select v-model="ruleForm.type" placeholder="请选择" size="small" @change="getyhq">
                                <el-option label="实物礼品" :value="3"></el-option>
                                <el-option label="商城优惠券" :value="1"></el-option>
                                <el-option label="咨询优惠券" :value="2"></el-option>
                                <el-option label="积分" :value="4"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="积分数量" style="margin-top:10px" prop="award_value" v-if="ruleForm.type==4">
                            <el-input v-model="ruleForm.award_value" placeholder="请输入积分数量" type="number" size="small">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="优惠券" style="margin-top:10px" prop="type_id"
                            v-if="ruleForm.type==1||ruleForm.type==2">
                            <el-select v-model="ruleForm.type_id" placeholder="请选择" size="small">
                                <el-option v-for="(y,index) in yhq_options" :key="index" :label="y.name" :value="y.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="奖品数量" style="margin-top:10px" prop="award_count">
                            <el-input v-model="ruleForm.award_count" placeholder="请输入奖品数量" type="number" size="small">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="奖品中奖率" style="margin-top:10px" prop="rate">
                            <el-input v-model="ruleForm.rate" style="max-width:100px" placeholder="中奖率" type="number"
                                size="small">
                            </el-input> %
                        </el-form-item>
                        <el-form-item label="奖品状态" style="margin-top:10px" prop="status">
                            <el-radio-group v-model="ruleForm.status">
                                <el-radio :label="1">显示</el-radio>
                                <el-radio :label="2">隐藏</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">确 定
                </el-button>
                <el-button @click="adddialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                proData: [],
                textId: '',
                loading: false,
                subloading: false,
                height: null,
                adddialogVisible: false,
                ruleForm: {
                    award_name: '',
                    award_describe: '',
                    award_cover: [],
                    grade: '',
                    type: 3,
                    type_id: '',
                    award_count: '',
                    rate: '',
                    status: 1,
                    award_value: 0,
                },
                problems: {
                    award_name: [{
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }, ],
                    award_describe: [{
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }, ],
                    grade: [{
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }, ],
                    type: [{
                        required: true,
                        message: '请选择',
                        trigger: 'blur'
                    }, ],
                    type_id: [{
                        required: true,
                        message: '请选择',
                        trigger: 'blur'
                    }, ],
                    award_count: [{
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }, ],
                    rate: [{
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }, ],
                    status: [{
                        required: true,
                        message: '请选择',
                        trigger: 'blur'
                    }, ],
                    award_value: [{
                        required: true,
                        message: '请输入积分',
                        trigger: 'blur'
                    }, ],

                },
                eid: '',
                proloading: false,

                yhq_options: [],
                mapListed: []
            }
        },
        mounted() {
            this.getHeight()
            // this.getlist()

        },
        methods: {
            floatMul(arg1, arg2) {
                var m = 0,
                    s1 = arg1.toString(),
                    s2 = arg2.toString();
                try {
                    m += s1.split(".")[1].length
                } catch (e) {}
                try {
                    m += s2.split(".")[1].length
                } catch (e) {}
                return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
            },
            getHeight() {
                let that = this
                that.height = window.innerHeight - 310 + 'px'
                window.onresize = () => {
                    that.height = window.innerHeight - 310 + 'px'
                }
            },
            handleAdd() {
                this.clearf()
                this.eid = ''
                this.adddialogVisible = true
            },
            clearf() {
                this.ruleForm = {
                    award_name: '',
                    award_describe: '',
                    award_cover: [],
                    grade: '',
                    type: 3,
                    type_id: '',
                    award_count: '',
                    rate: '',
                    status: 1,
                    award_value: '',
                }
            },
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.mapListed.push(response.data)
            },
            uploadRmove(file, fileList) {
                var index = this.mapListed.findIndex(item => item.id == file.id)
                this.mapListed.splice(index, 1)
            },
            search() {
                this.getlist(this.textId)
            },
            getlist(id) {
                this.proData = []
                this.proloading = true
                axios
                    .post("/admin/wssadmin/prizeGift/index", {
                        prize_id: id,

                    }, {
                        token: true
                    })
                    .then(response => {
                        this.proloading = false
                        if (response.data.code == '200') {
                            this.proData = response.data.data
                        } else {
                            that.$message.error(response.data.msg);
                        }
                    })
                    .catch(error => {})
            },
            getyhq(n) {
                this.ruleForm.type_id = ''
                this.yhq_options = []
                if (n == 1 || n == 2) {
                    axios
                        .get(`/admin/wss/coupon/allCouponSelect?couponType=${n}`, {}, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.yhq_options = response.data.data
                            } else {
                                this.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }
            },
            handleEdit(row, index) {
                this.ruleForm.award_name = row.award_name
                this.ruleForm.award_describe = row.award_describe
                this.ruleForm.grade = row.grade
                this.ruleForm.type = row.type
                this.getyhq(row.type)
                this.ruleForm.type_id = row.type_id
                this.ruleForm.award_count = row.award_count
                this.ruleForm.rate =  this.floatMul(row.rate,100)
                this.ruleForm.status = row.status
                this.ruleForm.award_cover = row.award_cover
                this.ruleForm.award_value = row.award_value
                this.mapListed = row.award_cover
                this.eid = row.id
                this.adddialogVisible = true
            },
            handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该问题, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.proloading = true
                    axios
                        .post("/admin/wssadmin/prizeGift/del", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.getlist(this.textId)
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        let urls
                        if (this.eid && this.eid != '') {
                            urls = "/admin/wssadmin/prizeGift/update"
                        } else {
                            urls = "/admin/wssadmin/prizeGift/save"
                        }
                        this.subloading = true
                        axios.post(urls, {
                                id: that.eid,
                                prize_id: this.textId,
                                grade: this.ruleForm.grade,
                                type: this.ruleForm.type,
                                type_id: this.ruleForm.type_id,
                                award_name: this.ruleForm.award_name,
                                award_count: this.ruleForm.award_count,
                                award_describe: this.ruleForm.award_describe,
                                award_cover: this.mapListed,
                                rate: this.ruleForm.rate,
                                status: this.ruleForm.status,
                                award_value: this.ruleForm.award_value,
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.adddialogVisible = false
                                    that.getlist(this.textId)
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = false
                            })
                    } else {
                        // this.$alert("信息遗漏未填")
                        return false;
                    }
                });
            },
            changeDefault(a) {
                axios
                    .post("/admin/wssadmin/prizeGift/setDefault", {
                        id: a,
                    }, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == '200') {
                            this.$message({
                                type: 'success',
                                message: '设置成功!'
                            });
                            this.getlist(this.textId)
                        } else {
                            this.$message.error(response.data.msg);
                        }
                    })
                    .catch(error => {})
            }
        },
        watch: {
            'ruleForm.choose_type'(val, old) {
                if (val == 3) {
                    this.ruleForm.options = [{
                        option: "",
                        // option_type: 1,
                        score: '',
                    }]
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .add_tits {
        padding: 0 10px;
    }
</style>